<template>
  <aside class="app-sidebar" :class="{ 'app-sidebar--collapsed': collapsed }">
    <!-- Logo -->
    <div class="sidebar-logo">
      <img
        src="https://crmred.co/images/_/_/_/_/redcrm/frontend/src/assets/images/logo/logo-crmred.svg"
        class="sidebar-logo__img"
        alt="CRMRed"
      />
      <span class="sidebar-logo__text">CRMRED</span>
    </div>

    <!-- Navigation -->
    <div class="sidebar-nav">
      <SidenavList :collapsed="collapsed" />
    </div>
  </aside>
</template>

<script>
import SidenavList from './SidenavList.vue'

export default {
  name: 'AppSidenav',
  components: { SidenavList },
  props: {
    collapsed: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.app-sidebar {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 260px;
  height: 100vh;
  background: #1E3A5F;
  transition: width 0.3s ease;
  overflow: hidden;
  z-index: 40;
}

.app-sidebar--collapsed {
  width: 70px;
}

.sidebar-logo {
  display: flex;
  align-items: center;
  height: 64px;
  padding: 0 16px;
  border-bottom: 1px solid rgba(255,255,255,0.08);
  flex-shrink: 0;
  gap: 10px;
}

.sidebar-logo__img {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  filter: brightness(0) invert(1);
}

.sidebar-logo__text {
  font-weight: 700;
  font-size: 0.85rem;
  color: #ffffff;
  letter-spacing: 0.05em;
  white-space: nowrap;
  overflow: hidden;
  transition: opacity 0.3s ease, width 0.3s ease;
}

.app-sidebar--collapsed .sidebar-logo__text {
  opacity: 0;
  width: 0;
}

.sidebar-nav {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 12px 0;
  scrollbar-width: thin;
  scrollbar-color: rgba(255,255,255,0.15) transparent;
}

.sidebar-nav::-webkit-scrollbar { width: 4px; }
.sidebar-nav::-webkit-scrollbar-thumb {
  background: rgba(255,255,255,0.15);
  border-radius: 4px;
}
</style>
